<template>
    <b-card class="a-propos">
        <h3>Qu’est-ce que le DVLF ?</h3>
        <p>
            Le dictionnaire vivant de la langue française (DVLF) est une nouvelle manière de consulter le dictionnaire.
            Bien que nous incluions les entrées de nombreux dictionnaires traditionnels, ainsi que des collocations et
            autres mots associés avec toute entrée de dictionnaire, nous avons aussi mis en place un dispositif qui rend
            possible votre propre contribution à notre base de données, vous permettant d’ajouter vous-même vos propres
            définitions, vos exemples, vos synonymes, ou vos antonymes. Nous avons ainsi réuni de nombreux exemples de
            phrases dans lesquels les mots recherchés sont utilisés, ce qui est utile pour voir de quelle manière l’utilisation
            d’un terme a pu évoluer à travers les siècles. En outre, vous pouvez voter pour les exemples que vous trouvez
            particulièrement pertinents et illustrant le sens d'un mot donné, permettant ainsi au DVLF de montrer automatiquement
            la meilleure information possible en s’appuyant sur votre participation. Le DVLF existe pour vous donner un
            meilleur dictionnaire, un dictionnaire qui reflète la manière dont VOUS utilisez les mots.</p>
        <h3>D’où viennent les données ?</h3>
        <p>
            <i>Définitions</i>
        </p>
        <ul>
            <li>
                <a href=" https://atilf.atilf.fr/tlf.htm" target="_blank">Le Trésor de la Langue Française informatisé (TLFi)</a>
            </li>
            <li>
                <a href="https://www.languefrancaise.net/bob/" target="_blank">Bob: dictionnaire arg. pop. fam.</a>
            </li>
            <li>
                <a href="https://artfl-project.uchicago.edu/node/17" target="_blank">Dictionnaires d'autrefois</a>
            </li>
        </ul>
        <i>Synonymes et antonymes</i>
        <ul>
            <li>
                <a href="https://www.crisco.unicaen.fr/cgi-bin/cherches.cgi" target="_blank">CRISCO</a>
            </li>
        </ul>
        <i>"Usage à travers le temps", collocations, et "mots associés"</i>
        <ul>
            <li>
                <a href="https://artfl-project.uchicago.edu/node/84" target="_blank">ARTFL-FRANTEXT Time Series</a>
            </li>
            <li>
                Collocations tirées de la base de données
                <a href="https://artfl-project.uchicago.edu/node/84" target="_blank">ARTFL-FRANTEXT</a> et d'autres textes littéraires français.
            </li>
            <li>
                Mots associés générés par un
                <a href="https://nlp.stanford.edu/projects/glove/" target="_blank">algorithme d'apprentissage automatique générant des vecteurs de mots</a>.
            </li>
        </ul>
        <i>Phrases en exemple</i>
        <ul>
            <li>
                <a href="https://www.lexique.org/public/corpatext.php" target="_blank">Corpatext</a>
            </li>
            <li>
                <a href="https://www.larecherche.fr/" target="_blank">La Recherche</a>
            </li>
            <li>
                <a href="https://www.lemonde.fr" target="_blank">Le Monde</a>
            </li>
            <li>
                <a href="https://www.sciencesetavenir.fr/" target="_blank">Sciences et Avenir</a>
            </li>
            <li>
                <a href="https://www.lesinrocks.com/" target="_blank">Les Inrockuptibles</a>
            </li>
            <li>
                <a href="https://www.lalibre.be/" target="_blank">La Libre</a>
            </li>
            <li>
                <a href="https://lesoir.be/" target="_blank">Le Soir</a>
            </li>
            <li>
                <a href="https://www.lnc.nc/" target="_blank">Les Nouvelles Calédoniennes</a>
            </li>
            <li>
                <a href="https://www.automobile-magazine.fr/" target="_blank">L’Automobile Magazine</a>
            </li>
            <li>
                Et bien d'autres !
            </li>
        </ul>
        <h3>Qui a mis en place le DVLF ?</h3>
        <p>
            Le DVLF a été à l'origine créé par l'
            <a href="https://artfl-project.uchicago.edu/" target="_blank">ARTFL Project</a> à
            <a href="https://www.uchicago.edu/index.shtml" target="_blank">l’Université de Chicago</a>
            par Tim Allen, Charles Cooney, Clovis Gladstone, et Russell Horton. Ce projet n'aurait jamais
            vu le jour sans la bourse du <a href="https://www.neh.gov/grants/guidelines/digitalhumanitiesstartup.html" target="_blank">National Endowment for the Humanities</a>,
            au soutien d'ARTFL (en particulier nos directeurs Robert Morrissey et Mark Olsen), et de la
            division des Humanités et du Computation Institute de l’Université de Chicago. Nous avions
            aussi grandement bénéficié des conseils de membres de l'équipe de
            <a href="https://www.wordnik.com/" target="_blank">Wordnik</a>
            tout au long du projet, et du travail fourni par les chercheurs à
            <a href="https://www.atilf.fr/" target="_blank">l'ATILF</a>,
            <a href="https://www.lexique.org/" target="_blank">au Lexique</a>, et à
            <a href="https://www.crisco.unicaen.fr/cgi-bin/cherches.cgi" target="_blank">CRISCO</a>,
            sans lesquels le DVLF n’aurait pu offrir une si large gamme de données.
        </p>
        <p>
            Les version 2.0 et 3.0 du DVLF ont été développées par Tim Allen, Charles Cooney, et Clovis Gladstone.
            Nous souhaitons remercier notre directeur et directeur adjoint (Robert Morrissey et Mark Olsen)
            pour leur soutien et encouragements dans cette mise à jour du projet.
        </p>
        <p style="text-align: center;">
            <a href="https://www.uchicago.edu/index.html" target="_blank">
                <img src="../assets/images/logo.rgb.black.png"></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="https://www.neh.gov/" target="_blank"><img src="../assets/images/neh__logo_hor_grayscale_small.jpg"></a>
        </p>
        Nous serions ravis de recueillir vos impressions, vos commentaires ou suggestions. Contactez-nous à
        <b>dvlf [at] artfl [dot] uchicago [dot] edu</b>
    </b-card>

</template>

<script>
import { EventBus } from "../main.js"

export default {
    name: "APropos",
    created() {
        EventBus.$emit("OffHome")
    }
}
</script>

<style scoped>
.a-propos {
    padding: 20px;
    margin-top: 25px;
}
</style>

